import { createContext } from 'react';
import WorkData from '../data/workData';

const WorkContext = createContext(WorkData);

export default WorkContext;